import { Component, signal } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { PaginationComponent } from "app/shared/components/pagination/pagination.component";
import { PurchaseAdminDashboardService, TradeInDto } from '../purchase-dashboard.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { environment } from 'app/environments/environment';
import { TranslocoPipe } from '@jsverse/transloco';
import { AlertService } from 'app/core/services/alert.service';

@Component({
  selector: 'app-trade-in-vehicles',
  templateUrl: './trade-in-vehicles.component.html',
  styleUrls: ['./trade-in-vehicles.component.css'],
  imports: [PaginationComponent, MatTableModule, MatButtonModule, MatIconModule, TranslocoPipe]
})
export class TradeInVehiclesComponent {
  environment = environment;

  displayedColumns: string[] = ['Vin number and model', 'Status', 'Contract link'];
  dataSource = signal<TradeInDto[]>([]);

  constructor(public purchaseAdminService: PurchaseAdminDashboardService, private alert: AlertService) {
    this.getVehicles();
  }

  getVehicles() {
    this.purchaseAdminService.getTradeInsVehicles().subscribe({
      next: (response) => {
        this.dataSource.set(response.result!);
        this.purchaseAdminService.tradeInsParams.update((currentParams) => ({
          ...currentParams, // Spread the existing state
          pagination: response.pagination!
        }));
      },
      error: (error) => {
        this.alert.errorFromHttp(error);
      }
    });
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  openDetails(id: string) {
    console.log(id);
    const url = `${environment.legacyUrl}vehiclecontract/edit/${id}`;
    window.open(url);
  }
}
